import React, { useState } from 'react'
import {  useTranslation } from 'react-i18next';

import {MwButton, MwInputText} from '../ui/';
import {BiMessageSquareAdd} from 'react-icons/bi'
import TagListItem from './TagListItem';

const TagList = ({tagList,setTagList,withLabel=false,label}) => {
    const [t] = useTranslation('global')
    const [inputTag,setInputTag] = useState('');

    const removeTag = (tag) => {
        const tagFilter =  tagList.filter(t => t !== tag); 
        setTagList(tagFilter)
    }
    const addTag = () =>{
        if(!inputTag) return;
        tagList?.includes(inputTag) ||  setTagList([...tagList , inputTag])
        setInputTag('')
    }
    const onKeyDown = (event) =>{
        if (event.key === 'Enter') {
            addTag()
        }
    }

    const tags = tagList?.map((tag,index) => ( <TagListItem key={index} tag={tag} removeTagHandler={()=>removeTag(tag)} />))

    return (
        <div className='flex-1 '>
            {withLabel && <label className='mb-1 block px-1 text-xs font-medium text-[#251658]'>{label}</label>}
            <div className='relative flex min-h-[44px] flex-col items-center text-xs'>
                <MwInputText
                    onKeyDown = {onKeyDown}
                    placeholder={t('invoice.enterTagName')}
                    value={inputTag}
                    onChange= {(e)=> setInputTag(e.target.value) }
                    />
                <div className='absolute end-1 top-1 '>
                    <MwButton actionType='button' type='secondary' size='sm' onClick={addTag}  ><BiMessageSquareAdd/></MwButton>
                </div>
                <div className='mt-2 flex w-full flex-wrap gap-1 text-slate-400'>
                    {tags}
                </div>
            </div>
        </div>
    )
}

export default TagList
